import { render, staticRenderFns } from "./Accept_cgu.vue?vue&type=template&id=6a5e898e&scoped=true&"
import script from "./Accept_cgu.vue?vue&type=script&lang=js&"
export * from "./Accept_cgu.vue?vue&type=script&lang=js&"
import style0 from "./Accept_cgu.vue?vue&type=style&index=0&id=6a5e898e&prod&lang=css&"
import style1 from "./Accept_cgu.vue?vue&type=style&index=1&id=6a5e898e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e898e",
  null
  
)

export default component.exports